
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.997 0C7.282 0 6.942.012 5.875.06c-1.063.05-1.79.218-2.427.465a4.9 4.9 0 00-1.77 1.153 4.9 4.9 0 00-1.153 1.77C.277 4.085.109 4.812.06 5.875.01 6.942 0 7.282 0 9.997s.012 3.055.06 4.121c.05 1.064.218 1.791.465 2.428a4.9 4.9 0 001.153 1.77 4.91 4.91 0 001.77 1.153c.637.247 1.364.415 2.427.464 1.067.049 1.407.06 4.122.06s3.055-.011 4.121-.06c1.064-.047 1.791-.218 2.428-.464a4.902 4.902 0 001.77-1.154 4.902 4.902 0 001.153-1.77c.247-.636.415-1.363.464-2.427.049-1.066.06-1.406.06-4.12 0-2.716-.011-3.056-.06-4.123-.047-1.063-.218-1.79-.464-2.427a4.901 4.901 0 00-1.154-1.77 4.9 4.9 0 00-1.77-1.153C15.91.277 15.183.109 14.119.06 13.052.01 12.712 0 9.998 0zm0 1.8c2.67 0 2.986.012 4.04.06.974.045 1.503.207 1.856.345.466.18.8.397 1.149.747.35.349.566.682.748 1.149.136.353.3.882.345 1.856.047 1.055.058 1.37.058 4.04s-.011 2.986-.059 4.04c-.045.974-.207 1.503-.344 1.856a3.1 3.1 0 01-.748 1.149 3.097 3.097 0 01-1.15.748c-.352.136-.881.3-1.856.345-1.054.047-1.37.058-4.039.058-2.67 0-2.986-.011-4.04-.059-.974-.045-1.503-.207-1.856-.344a3.097 3.097 0 01-1.15-.748 3.097 3.097 0 01-.747-1.15c-.137-.352-.3-.881-.345-1.856-.047-1.054-.058-1.37-.058-4.039 0-2.67.01-2.985.058-4.04.046-.974.208-1.503.346-1.856.18-.466.397-.8.747-1.15A3.097 3.097 0 014.1 2.205c.353-.137.882-.3 1.856-.345 1.055-.047 1.37-.058 4.04-.058z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M9.997 13.33a3.332 3.332 0 110-6.666 3.332 3.332 0 010 6.665zm0-8.466A5.134 5.134 0 109.86 15.13a5.134 5.134 0 00.137-10.267zm6.535-.203a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0","clip-rule":"evenodd"}})])
          )
        }
      }
    